export const socialsData = {
    github: 'https://github.com/Aftab1999',
    linkedIn: 'https://www.linkedin.com/in/aftab1999',
    instagram: 'https://www.instagram.com/_aftab_1515',
    
}